import React, { Component } from 'react';

import Banner from './Banner';
import Content from './Content';
import Footer from '../Index/Footer';

class Eventos extends Component {
    constructor (props) {
        super (props);
        this.scrollIni();
    }

    scrollIni = () => {
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });
    }
    
    render() {
        return(
            <div style={{paddingLeft:0, paddingRight: 0,}}>
                <Banner/>
                <Content/>
                <Footer/>
            </div>
        );
    }
}
 
export default Eventos;


// WEBPACK FOOTER //
// ./src/site/Componentes/Eventos/Eventos.jsx